var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuturestep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H1",
    stroke: "#000",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.93 14h-5.59v-.78l2.953-3.28c.438-.497.738-.899.902-1.208.168-.312.252-.634.252-.966 0-.446-.135-.81-.404-1.096-.27-.285-.629-.428-1.078-.428-.54 0-.96.154-1.26.463-.297.305-.445.73-.445 1.277h-1.084c0-.785.252-1.42.756-1.904.508-.484 1.185-.726 2.033-.726.793 0 1.42.209 1.88.627.462.414.692.966.692 1.658 0 .84-.535 1.84-1.605 3l-2.285 2.478h4.283V14z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#000"
  })));
}
SvgFuturestep2.displayName = 'Futurestep2';
export default SvgFuturestep2;